import { BRAND } from "@/data/products";
import { brl } from "@/lib/format";

export const waLink = (text) =>
  `https://api.whatsapp.com/send?phone=${BRAND.phoneE164}&text=${encodeURIComponent(text)}`;

const sizeLabel = (size) => size ? `${size.label} · ${size.dim}` : "-";

export const buildQuickProductMessage = ({ product, size, price }) => {
  const lines = [
    `*Olá! Tenho interesse na coroa ${product.ref}.*`,
    "",
    `• Modelo: *${product.name}* (${product.ref})`,
    `• Descrição: ${product.description}`,
    `• Tamanho: *${sizeLabel(size)}*`,
    `• Valor: *${brl(price)}*`,
    "",
    "Poderia me ajudar a fechar o pedido?",
  ];
  return lines.join("\n");
};

export const buildSingleOrderMessage = ({ product, size, price, faixa, quantity }) => {
  const lines = [
    "*Olá! Gostaria de fazer um pedido:*",
    "",
    `• Modelo: *${product.name}* (${product.ref})`,
    `• Tamanho: *${sizeLabel(size)}*`,
    `• Quantidade: *${quantity}x*`,
    `• Valor unitário: *${brl(price)}*`,
  ];
  if (faixa && faixa.trim()) lines.push(`• Faixa personalizada: "${faixa.trim()}"`);
  lines.push("", "Aguardo retorno para finalizar. Obrigado(a).");
  return lines.join("\n");
};

export const buildCartMessage = ({ items, customer }) => {
  const lines = [
    "*Olá! Gostaria de fazer o pedido abaixo na Central de Coroas de Flores:*",
    "",
  ];

  let total = 0;

  items.forEach((it, i) => {
    lines.push(`*${i + 1}.* ${it.product.name} (${it.product.ref})`);
    if (it.size) lines.push(`   • Tamanho: ${sizeLabel(it.size)}`);
    lines.push(`   • Quantidade: ${it.quantity}x`);
    const subtotal = it.price * it.quantity;
    total += subtotal;
    lines.push(`   • Subtotal: ${brl(subtotal)}`);
    if (it.faixa && it.faixa.trim()) lines.push(`   • Faixa: "${it.faixa.trim()}"`);
    lines.push("");
  });

  lines.push(`*Total:* ${brl(total)}`);
  lines.push("");
  lines.push("*Dados de entrega:*");
  if (customer.name)       lines.push(`• Nome: ${customer.name}`);
  if (customer.phone)      lines.push(`• Telefone: ${customer.phone}`);
  if (customer.velorio)    lines.push(`• Velório / Endereço: ${customer.velorio}`);
  if (customer.deliveryAt) lines.push(`• Entrega para: ${customer.deliveryAt}`);
  if (customer.notes)      lines.push(`• Observações: ${customer.notes}`);
  lines.push("", "Aguardo confirmação. Obrigado(a).");

  return lines.join("\n");
};
